import { Icon } from '../../components/icons/Icon'

export interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string | undefined
  label: string
}

/** Free-text search across searchable columns — debouncing lives in the caller (useDebouncedValue). */
export function SearchInput({ value, onChange, placeholder, label }: SearchInputProps) {
  return (
    <div style={{ position: 'relative', flex: '0 1 260px', minWidth: 180 }}>
      <Icon
        name="search"
        size={14}
        style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'var(--iw-text-subtle)',
          pointerEvents: 'none',
        }}
      />
      <label className="iw-visually-hidden" htmlFor="iw-list-search">
        {label}
      </label>
      <input
        id="iw-list-search"
        type="search"
        className="iw-input"
        style={{ width: '100%', paddingLeft: 30 }}
        value={value}
        placeholder={placeholder ?? 'Search…'}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}
